module.exports = __webpack_public_path__ + "img/agrotis-ipsilon.5fbc4c11.jpg";